module.exports = __webpack_public_path__ + "static/interactive-tool-image_NA-4a0836a5b85921d7249c77ffc9f2bdc4.jpg";